const DOMO_LOGO_URL =
  "https://cdn.prod.website-files.com/6201da6cd7d75f4e415870c5/68c2b2012ad925d34a74f0c9_domo.svg";
const ILLIO_LOGO_URL =
  "https://uploads-ssl.webflow.com/60b7a1112331947d8a44a36d/60b7a472b76004ab6b185470_illio-logo.svg";

export const getLogoUrl = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("illio")) {
    return ILLIO_LOGO_URL;
  }
  return DOMO_LOGO_URL;
};
